import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  EntityModelLipidQuantity,
  LipidQuantity,
  LipidQuantityControllerService,
  PagedModelEntityModelLipidQuantity,
  PlottableLipidQuantityControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";

@Component({
  selector: "app-admin-lipidquantity",
  templateUrl: "./admin-lipidquantity.component.html",
  styleUrls: ["./admin-lipidquantity.component.css"],
  standalone: true,
  imports: [CrudTableComponent]
})
export class AdminLipidquantityComponent implements OnInit {
  private controller = inject(LipidQuantityControllerService);
  private plottableController = inject(PlottableLipidQuantityControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[];
  filterFields: string[];
  crudAdapter: CrudAdapter<
    PagedModelEntityModelLipidQuantity,
    EntityModelLipidQuantity
  >;

  ngOnInit() {
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "lipids",
        header: "Lipids",
        filterType: ColumnFilterType.Object,
        content: value => value,
        visible: true
      },
      {
        field: "assayQuantity",
        header: "Quantity",
        filterType: ColumnFilterType.Numeric,
        content: value => value,
        visible: true
      },
      {
        field: "quantificationUnit",
        header: "DB Quant Unit",
        filterType: ColumnFilterType.Object,
        content: value => value,
        visible: true
      },
      {
        field: "nativeQuantificationUnit",
        header: "Native Quant Unit",
        filterType: ColumnFilterType.Object,
        content: value => value,
        visible: true
      }
      // {
      //   field: "lipidLevel",
      //   header: "Structural Level",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value,
      // },
      // {
      //   field: "lipidCategory",
      //   header: "Category",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value,
      // },
      // {
      //   field: "lipidClass",
      //   header: "Class",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value,
      // },
      // {
      //   field: "lipidSpecies",
      //   header: "Species",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value,
      // },
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new LipidQuantityCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }

  //   clearAllCaches() {
  //     this.plottableController.clearCache().subscribe(() => {
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Caches cleared',
  //         detail: 'All lipid quantity caches have been cleared.',
  //       });
  //     });
  // }
}
class LipidQuantityCrudAdapter extends CrudAdapter<
  PagedModelEntityModelLipidQuantity,
  EntityModelLipidQuantity
> {
  constructor(
    private controller: LipidQuantityControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelLipidQuantity> {
    return this.controller.lipidQuantityGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelLipidQuantity[] {
    return <EntityModelLipidQuantity[]>entries?._embedded?.lipidQuantities;
  }

  saveSingle(
    entity: EntityModelLipidQuantity,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelLipidQuantity> {
    return this.controller.lipidQuantitySaveSingle(
      <LipidQuantity>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.lipidQuantityDeleteById(id, observe, reportProgress, options);
  }
}
